import { plural } from './plural';

/** Zumpo/Snap symbol's names, in variant order, as a sentence says them. */
export const symbols = [
  'circle',
  'ring',
  'half circle',
  'square',
  'diamond',
  'triangle',
  'star',
  'sparkle',
  'hexagon',
  'heart',
  'moon',
  'plus',
  'drop',
  'cloud',
  'leaf',
  'flower',
  'bolt',
  'arrow',
  'house',
  'fish',
  'bow',
  'tree',
  'mushroom',
  'bell',
  'clover',
  'note',
  'eye',
  'crown',
  'pill',
  'ghost',
  'cup',
];

export const snap = {
  middleCard: 'Middle card',
  yourCard: 'Your card',
  lastCard: 'Last card',
  /** Above the middle card: the cards still to take, it among them. */
  left: (count: number) => `${count} left`,
  /** Above your card in a room: the cards you have taken. */
  won: (count: number) => `${count} won`,
  progress: (taken: number, total: number) =>
    `${taken} of ${plural(total, 'card')}`,
  gameOver: 'Game over',
  gameEnded: 'Game ended',
  waitingRoom: 'Waiting room',
  chat: 'Say something…',
  you: 'You',
  resultDetail: (count: number) => `${plural(count, 'card')} taken in all.`,
  alone: 'Better with company.',
  setup: (players: number, cards: number) =>
    `${plural(players, 'player')}, ${plural(cards, 'card')} to win. Everybody races to spot the symbol their card shares with the middle card.`,
  guestSetup: (players: number, cards: number) =>
    `${plural(players, 'player')}, ${plural(cards, 'card')} to win.`,
  oneOnBoth: 'One symbol on both cards',
  spot: 'Spot the match',
  firstTakes: 'The first right tap takes the middle card',
  watching: 'You’re watching',
  everyoneLooking: 'Everyone is looking',
  onThisCard: 'on this card',
  paused: 'paused',
  taken: 'Card taken',
  youTook: 'You took it!',
  tookIt: (name: string) => `${name} took it`,
  wasOnBoth: (symbol: number) => `The ${symbols[symbol]} was on both cards`,
  nextCard: 'next card',
  lockedTitle: 'Locked out',
  notMatch: 'Not a match',
  onlyOn: (symbol: number, on: 'mine' | 'middle') =>
    `The ${symbols[symbol]} is only on ${on === 'mine' ? 'your card' : 'the middle card'}`,
  lockedOut: 'locked out',
  stillLocked: 'Still locked out',
  tapAfterLockout: 'A new card is up; tap when the lockout ends',
  away: 'Away',
  waiting: 'Waiting',
  tookCard: 'Took the card',
  looking: 'Looking',
  solo: {
    rule: 'Tap the symbol on both cards, and the middle card becomes yours. A wrong tap adds 3 seconds.',
    whatMakesMatch: 'What makes a match',
    example: 'Every two cards share exactly one symbol.',
    notYet: 'Not yet',
    complete: 'Run complete',
    allTaken: (count: number) => `All ${count} cards taken`,
    resultTitle: (count: number, time: string) => `${count} cards in ${time}.`,
    wrongTaps: 'Wrong taps',
    fastest: 'Fastest card',
    slowest: 'Slowest card',
    none: 'Not yet',
    best: 'Best on this device',
    challenge: (time: string) =>
      `They get this same deck and try to beat ${time}.`,
    progress: (count: number, total: number) => `Card ${count} of ${total}`,
    thisRun: 'This run',
    thirtyCards: 'Thirty cards',
    runTime: 'Time',
    tapBoth: 'Tap the symbol on both cards',
    match: 'A match!',
    foundIn: (time: string) => `Found in ${time}`,
    wrong: 'Not a match, +3 s',
    firstRun: 'Your first run on this device.',
    newBest: (time: string) =>
      `A new best on this device. Your last best was ${time}.`,
    previousBest: (time: string) => `Your best on this device is ${time}.`,
    cost: (count: number, time: string) => (count ? `${count}, +${time}` : '0'),
  },
};
